import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { ApolloQueryResult } from 'apollo-client'

const STORE_FEEDBACK = gql`
  mutation StoreFeedback($feedback: String!) {
    storeFeedback(feedback: $feedback)
  }
`

type Response = {
  storeFeedback: boolean
}

export type WithFeedbackProps = {
  storeFeedback: (feedback: string) => Promise<ApolloQueryResult<Response>>
}

export function withStoreFeedback<T>() {
  return graphql<Response, T, WithFeedbackProps>(STORE_FEEDBACK, {
    props: ({ mutate }) => ({
      storeFeedback: (feedback: string) =>
        mutate && mutate({ variables: { feedback } })
    })
  })
}



// WEBPACK FOOTER //
// ./src/Components/FeedbackForm/feedbackQueries.ts